/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { mdiClose, mdiCursorMove, mdiRotateLeft, mdiRestore } from '@mdi/js';
import Icon from '@mdi/react';

import { BATemplate } from '@companycam/companycam-bacore';
import {
  PAN_MODE_SURFACE,
  PAN_MODE_BEFORE,
  PAN_MODE_AFTER,
  WGLRenderer,
} from './wglrender';

// enums
const TOOLBAR_MODE_DEFAULT = 'TOOLBAR_MODE_DEFAULT';
const TOOLBAR_MODE_EDIT_BEFORE = 'TOOLBAR_MODE_EDIT_BEFORE';
const TOOLBAR_MODE_EDIT_AFTER = 'TOOLBAR_MODE_EDIT_AFTER';

class CCBAWeb extends Component {
  constructor(props) {
    super(props);

    const { templateDefs } = props;
    const { imageMask, imageOverlay, templatePOJO } = templateDefs[0];
    this.state = {
      imageMask,
      imageOverlay,
      templatePOJO,
      swap: false,
      panMode: PAN_MODE_SURFACE,
      toolbarMode: TOOLBAR_MODE_DEFAULT,
    };
  }

  getImageBefore() {
    return this.state.swap ? this.props.imageAfter : this.props.imageBefore;
  }

  getImageAfter() {
    return this.state.swap ? this.props.imageBefore : this.props.imageAfter;
  }

  renderIcons() {
    const elts = [];

    const selTempl = new BATemplate(this.state.templatePOJO);
    const selTitle = selTempl.getTitle();

    const { templateDefs } = this.props;
    for (let i = 0; i < templateDefs.length; i++) {
      const { imageIcon, imageMask, imageOverlay, templatePOJO } = templateDefs[
        i
      ];

      const curTempl = new BATemplate(templatePOJO);
      const curTitle = curTempl.getTitle();

      const onClick = () => {
        this.setState({
          imageMask,
          imageOverlay,
          templatePOJO,
        });
      };

      const wrapStyles = ['icon-wrapper'];
      if (curTitle === selTitle) {
        wrapStyles.push('is-selected');
      }

      const iconElt = (
        <div key={curTitle} className={wrapStyles.join(' ')}>
          <span className="icon-title">{curTitle}</span>
          <img className="icon-img" src={imageIcon} alt="" onClick={onClick} />
        </div>
      );
      elts.push(iconElt);
    }

    return elts;
  }

  renderChooserScreen() {
    let toolbarContent = null;
    switch (this.state.toolbarMode) {
      case TOOLBAR_MODE_EDIT_BEFORE:
        toolbarContent = (
          <div className="header-actions">
            <div className="header-left">
              <a
                href="#"
                className="header-btn close"
                onClick={(e) => {
                  if (e) {
                    e.preventDefault();
                  }
                  this.props.onCancelChooser();
                }}
              >
                <Icon className="action-image" path={mdiClose} />
              </a>
            </div>

            <div className="header-middle">
              <a
                href="#"
                className="mode-action"
                onClick={(e) => {
                  if (e) {
                    e.preventDefault();
                  }
                  if (!this._wglRenderer) {
                    return;
                  }
                  this._wglRenderer.rotateA();
                }}
              >
                <Icon className="action-image" path={mdiRotateLeft} />
                <span className="action-name">Rotate</span>
              </a>
              <a
                href="#"
                className={[
                  'mode-action',
                  this.state.panMode === PAN_MODE_BEFORE ? 'is-selected' : '',
                ].join(' ')}
                onClick={(e) => {
                  if (e) {
                    e.preventDefault();
                  }
                  if (this.state.panMode === PAN_MODE_BEFORE) {
                    this.setState({ panMode: PAN_MODE_SURFACE });
                  } else {
                    this.setState({ panMode: PAN_MODE_BEFORE });
                  }
                }}
              >
                <Icon className="action-image" path={mdiCursorMove} />
                <span className="action-name">Move</span>
              </a>
              <div className="action-spacer" />
              <a
                href="#"
                className="mode-action"
                onClick={(e) => {
                  if (e) {
                    e.preventDefault();
                  }
                  if (!this._wglRenderer) {
                    return;
                  }
                  this._wglRenderer.resetA();
                }}
              >
                <Icon className="action-image" path={mdiRestore} />
                <span className="action-name">Reset</span>
              </a>
            </div>

            <div className="header-right">
              <a
                href="#"
                className="header-btn done"
                onClick={(e) => {
                  if (e) {
                    e.preventDefault();
                  }
                  this.setState({
                    toolbarMode: TOOLBAR_MODE_DEFAULT,
                    panMode: PAN_MODE_SURFACE,
                  });
                }}
              >
                Save Before
              </a>
            </div>
          </div>
        );
        break;
      case TOOLBAR_MODE_EDIT_AFTER:
        toolbarContent = (
          <div className="header-actions">
            <div className="header-left">
              <a
                href="#"
                className="header-btn close"
                onClick={(e) => {
                  if (e) {
                    e.preventDefault();
                  }
                  this.props.onCancelChooser();
                }}
              >
                <Icon className="action-image" path={mdiClose} />
              </a>
            </div>

            <div className="header-middle">
              <a
                href="#"
                className="mode-action"
                onClick={(e) => {
                  if (e) {
                    e.preventDefault();
                  }
                  if (!this._wglRenderer) {
                    return;
                  }
                  this._wglRenderer.rotateB();
                }}
              >
                <Icon className="action-image" path={mdiRotateLeft} />
                <span className="action-name">Rotate</span>
              </a>
              <a
                href="#"
                className={[
                  'mode-action',
                  this.state.panMode === PAN_MODE_AFTER ? 'is-selected' : '',
                ].join(' ')}
                onClick={(e) => {
                  if (e) {
                    e.preventDefault();
                  }
                  if (this.state.panMode === PAN_MODE_AFTER) {
                    this.setState({ panMode: PAN_MODE_SURFACE });
                  } else {
                    this.setState({ panMode: PAN_MODE_AFTER });
                  }
                }}
              >
                <Icon className="action-image" path={mdiCursorMove} />
                <span className="action-name">Move</span>
              </a>
              <div className="action-spacer" />
              <a
                href="#"
                className="mode-action"
                onClick={(e) => {
                  if (e) {
                    e.preventDefault();
                  }
                  if (!this._wglRenderer) {
                    return;
                  }
                  this._wglRenderer.resetB();
                }}
              >
                <Icon className="action-image" path={mdiRestore} />
                <span className="action-name">Reset</span>
              </a>
            </div>

            <div className="header-right">
              <a
                href="#"
                className="header-btn done"
                onClick={(e) => {
                  if (e) {
                    e.preventDefault();
                  }
                  this.setState({
                    toolbarMode: TOOLBAR_MODE_DEFAULT,
                    panMode: PAN_MODE_SURFACE,
                  });
                }}
              >
                Save After
              </a>
            </div>
          </div>
        );
        break;
      case TOOLBAR_MODE_DEFAULT:
      default:
        toolbarContent = (
          <div className="header-actions">
            <div className="header-left">
              <a
                href="#"
                className="header-btn close"
                onClick={(e) => {
                  if (e) {
                    e.preventDefault();
                  }
                  this.props.onCancelChooser();
                }}
              >
                <Icon className="action-image" path={mdiClose} />
              </a>
            </div>

            <div className="header-middle">
              <a
                href="#"
                className="header-btn btn-normal"
                onClick={(e) => {
                  if (e) {
                    e.preventDefault();
                  }
                  this.setState({ toolbarMode: TOOLBAR_MODE_EDIT_BEFORE });
                }}
              >
                Edit Before Photo
              </a>
              <a
                href="#"
                className="header-btn btn-normal"
                onClick={(e) => {
                  if (e) {
                    e.preventDefault();
                  }
                  this.setState({ toolbarMode: TOOLBAR_MODE_EDIT_AFTER });
                }}
              >
                Edit After Photo
              </a>
              <a
                href="#"
                className="header-btn btn-normal"
                onClick={(e) => {
                  if (e) {
                    e.preventDefault();
                  }
                  const oldSwap = this.state.swap;
                  this.setState({ swap: !oldSwap });
                }}
              >
                Swap Photos
              </a>
            </div>

            <div className="header-right">
              <a
                href="#"
                className="header-btn save"
                onClick={(e) => {
                  if (e) {
                    e.preventDefault();
                  }
                  if (!this._wglRenderer) {
                    return;
                  }
                  this._wglRenderer.requestSave((dataURL) => {
                    this.props.onSave(dataURL);
                  });
                }}
              >
                Save
              </a>
            </div>
          </div>
        );
    }

    return (
      <div className="root-wrapper">
        <div className="header-wrapper">{toolbarContent}</div>
        <WGLRenderer
          ref={(c) => {
            this._wglRenderer = c;
          }}
          templatePOJO={this.state.templatePOJO}
          imageMask={this.state.imageMask}
          imageOverlay={this.state.imageOverlay}
          imageBefore={this.getImageBefore()}
          imageAfter={this.getImageAfter()}
          imageLogo={this.props.imageLogo}
          panMode={this.state.panMode}
        />
        <div className="icon-bar-wrapper">{this.renderIcons()}</div>
      </div>
    );
  }

  render() {
    return this.renderChooserScreen();
  }
}

CCBAWeb.propTypes = {
  templateDefs: PropTypes.array,

  imageBefore: PropTypes.string.isRequired,
  imageAfter: PropTypes.string.isRequired,
  imageLogo: PropTypes.string.isRequired,

  onCancelChooser: PropTypes.func,
  onSave: PropTypes.func,
};

CCBAWeb.defaultProps = {
  templateDefs: [],
  onCancelChooser: () => {},
  onSave: () => {},
};

export default CCBAWeb;
